import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AgentLanguageResponse } from '../models/responses/agent-language-reponse';
import { VoiceProvider } from '../models/enums/voice-provider';

const ENGLISH_LANGUAGE_CODE = "en";
const MULTILINGUAL_PROVIDERS = [VoiceProvider.OPENAI, VoiceProvider.CARTESIA,VoiceProvider.PLAYHT,VoiceProvider.ELEVENLABS];

// custom validator to check that two fields match
export function validLanguageVoiceProvider(agentLanguageControlName: string, voicesControlName: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const agentLanguageControl = formGroup.get(agentLanguageControlName);
        const voiceNameControl = formGroup.get(voicesControlName);

        const controls = [agentLanguageControl, voiceNameControl];

        for (const control of controls) {
            if (control?.errors && !control.errors['validLanguageVoiceProvider']) {
                // return if another validator has already found an error on the matchingControl
                return null;
            }
        }

        agentLanguageControl?.setErrors(null);
        voiceNameControl?.setErrors(null);

        let selectedLanguageValue = formGroup.value['agentLanguages'];
        const selectedLanguages: AgentLanguageResponse[] = Array.isArray(selectedLanguageValue) ? selectedLanguageValue : [selectedLanguageValue];
        const voiceProvider: VoiceProvider = formGroup.value['voiceProvider'];

        if (selectedLanguages.some(x => x.language != ENGLISH_LANGUAGE_CODE) && !MULTILINGUAL_PROVIDERS.includes(voiceProvider)) {
            agentLanguageControl?.setErrors({ validLanguageVoiceProvider: true });
            voiceNameControl?.setErrors({ validLanguageVoiceProvider: true });
            return { validLanguageVoiceProvider: true };
        } else {
            return null;
        }
    }
}

